export const AMPERSAND = 'Ampersand'
export const ASSIGNMENT = 'Assignment'
export const AT_SIGN = 'AtSign'
export const BACKWARD_SLASH = 'BackwardSlash'
export const CLOSE_BRACKET = 'CloseBracket'
export const CLOSE_CURLY_BRACE = 'CloseCurlyBrace'
export const CLOSE_PARENTHESIS = 'CloseParenthesis'
export const COLON = 'Colon'
export const COMMA = 'Comma'
export const DIVIDE = 'Divide'
export const DOLLAR_SIGN = 'DollarSign'
export const DOT = 'Dot'
export const EQUALITY = 'Equality'
export const GREATER_THAN = 'GreaterThan'
export const GREATER_THAN_EQUAL = 'GreaterThanEqual'
export const IN = 'In'
export const IS = 'Is'
export const INEQUALITY = 'Inequality'
export const INFINITY = 'Infinity'
export const LESS_THAN = 'LessThan'
export const LESS_THAN_EQUAL = 'LessThanEqual'
export const LOGICAL_AND = 'LogicalAnd'
export const LOGICAL_NOT = 'LogicalNot'
export const LOGICAL_OR = 'LogicalOr'
export const MODULUS = 'Modulus'
export const MULTIPLY = 'Multiply'
export const OPEN_BRACKET = 'OpenBracket'
export const OPEN_CURLY_BRACE = 'OpenCurlyBrace'
export const OPEN_PARENTHESIS = 'OpenParenthesis'
export const QUESTION_MARK = 'QuestionMark'
export const SEMICOLON = 'Semicolon'
export const TILDE = 'Tilde'
export const UNARY_MINUS = 'UnaryMinus'
export const UNARY_PLUS = 'UnaryPlus'
